import React, { useEffect, useState } from 'react'
import { Button, Modal, Container, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import api from '../api/api';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useNavigate, useParams } from 'react-router-dom';
import './Recommendations.css';


const AllRecommendations = () => {

  
    const params = useParams()
    let id = params.id
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const [recommendations, setRecmnd] = useState([])

    const { t } = useTranslation();

    const [toggle, setToggle] = useState(false)

    const [descriptionRec, setRecDescription] = useState('')
    const [titleRec,setRecTitle] = useState('')

    useEffect(() => {
        getRecommendation();

    }, [])



    const getRecommendation = async () => {
        let field_id = id
        await api.get(`/recommendations/${field_id}`)
            .then(response => {
                let recommendations = response.data.recommendations
                setRecmnd(recommendations)
                setIsLoading(false)
            }).catch(err => {
                console.error(err)
                setIsLoading(false)
            })
    }

    const openModal = (itemUid) => {
        let recommendation_uid = itemUid
        api.post('/recommendation/single-recommendation', { recommendation_uid })
            .then(response => {
                let recommendation = response.data.recommendation
                setRecDescription(recommendation.description)
                setRecTitle(recommendation.title)
                setToggle(true)
            }).catch(err => {
                console.error(err)
            })
    }

        const markAsRead = (itemUid) =>{
            let recommendation_uid = itemUid

            api.post('/recommendation/viewed',{recommendation_uid})
            .then(response=>{
                getRecommendation()
            }).catch(err=>{
                console.error(err)
            })
        }

        const markAsNotRead = (itemUid) => {
            let recommendation_uid = itemUid

            api.post('/recommendation/not-viewed', { recommendation_uid })
                .then(response => {
                    if (response.data.type === "success") {
                        getRecommendation()
                    }
                }).catch(err => {
                    console.error(err)
                })
        }


    return (
        <>
            <Container fluid className="recommendations-page p-3 p-md-4">
                <header className="recommendations-hero">
                    <div>
                        <span className="recommendations-eyebrow">SMARTFARM · {t('overview')}</span>
                        <h1>{t('recommendations')}</h1>
                        <p>{t('title_recomnd')}</p>
                    </div>
                    <Button
                        variant="outline-secondary"
                        className="recommendations-back-button"
                        onClick={() => navigate(`/Fields/${id}`)}
                    >
                        <i className="fas fa-arrow-left" aria-hidden="true" />
                        <span>{t('field')}</span>
                    </Button>
                </header>
                {
                    isLoading
                    ?
                        <LoadingSpinner />
                    :
                    <Card className="recommendations-card">
                        <div className="recommendations-card-header">
                            <div className="recommendations-title-icon"><i className="fas fa-lightbulb" aria-hidden="true" /></div>
                            <div>
                                <span>{t('title_recomnd')}</span>
                                <small>{recommendations.length} {t('recommendations')}</small>
                            </div>
                        </div>
                        <div className="table-responsive">
                                <table className="table mb-0 recommendations-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t('title')}</th>
                                            <th scope="col">{t('date')}</th>
                                            <th scope="col" aria-label={t('actions')}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recommendations.length === 0 ? (
                                            <tr>
                                                <td colSpan="3" className="recommendations-empty-state">
                                                    <i className="fas fa-lightbulb" aria-hidden="true" />
                                                    <span>{t('no_recommendations', { defaultValue: 'No recommendations available for this field.' })}</span>
                                                </td>
                                            </tr>
                                        ) : (
                                           recommendations.map(item => {
                                                let dateTime = item.created_at
                                                let dateRecmnd = dateTime.slice(0, 16).replace('T', ' ');
                                                const markReadLabel = t('mark_as_read', { defaultValue: 'Mark as read' });
                                                const markUnreadLabel = t('mark_as_unread', { defaultValue: 'Mark as unread' });
                                                return (

                                                    <tr key={item.uid} className={`${item.viewed == 0 ? 'font-weight-bold statsBox' : ''}`}>
                                                        <td
                                                            onClick={() => openModal(item.uid)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    openModal(item.uid);
                                                                }
                                                            }}
                                                            role="button"
                                                            tabIndex={0}
                                                            className='recommendations-table-title text-uppercase'
                                                        >
                                                            {item.title}
                                                        </td>
                                                        <td>{dateRecmnd}</td>
                                                        <td>
                                                            {
                                                                item.viewed == 0
                                                                ?
                                                                <button type="button" title={markReadLabel} aria-label={markReadLabel} onClick={()=> markAsRead(item.uid)} className="recommendation-read-button"><i className="fas fa-check" aria-hidden="true" /></button>
                                                                :
                                                                <button type="button" title={markUnreadLabel} aria-label={markUnreadLabel} onClick={() => markAsNotRead(item.uid)} className="recommendation-read-button is-read"><i className="fas fa-envelope-open" aria-hidden="true" /></button>


                                                            }
                                                        </td>

                                                    </tr>
                                                )

                                            })
                                        )}
                                    </tbody>
                                </table>

                        </div>
                    </Card>

                }
            </Container>
            <Modal centered show={toggle} onHide={() => setToggle(false)} dialogClassName="recommendation-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{titleRec}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {descriptionRec}

                </Modal.Body>
            </Modal>
        </>

    )
}

export default AllRecommendations
